import * as yup from 'yup';

import { TFunction } from 'i18next';
import { locationShape } from '@/schemas/sub-schemas';

const TITLE_MIN_LENGTH = 2;
export const TITLE_MAX_LENGTH = 100;

const DESC_MIN_LENGTH = 2;
export const DESC_MAX_LENGTH = 1000;

const LocationValidationSchema = (t: TFunction) =>
  yup.object({
    title: yup
      .string()
      .min(
        TITLE_MIN_LENGTH,
        t('validation:min_length', {
          name: t('the_title'),
          min: TITLE_MIN_LENGTH
        }) || undefined
      )
      .max(
        TITLE_MAX_LENGTH,
        t('validation:max_length', {
          name: t('the_title'),
          max: TITLE_MAX_LENGTH
        }) || undefined
      )
      .required(
        t('validation:is_required', {
          name: t('the_title')
        }) || undefined
      ),
    description: yup
      .string()
      .min(
        DESC_MIN_LENGTH,
        t('validation:min_length', {
          name: t('description'),
          min: DESC_MIN_LENGTH
        }) || undefined
      )
      .max(
        DESC_MAX_LENGTH,
        t('validation:max_length', {
          name: t('description'),
          max: DESC_MAX_LENGTH
        }) || undefined
      )
      .required(
        t('validation:is_required', {
          name: t('description')
        }) || undefined
      ),

    location: locationShape({ t, name: t('location') }).required(
      t('validation:is_required', {
        name: t('location')
      })
    ),
    sports: yup.array().of(yup.string())
  });

export type LocationSchemaData = yup.InferType<
  ReturnType<typeof LocationValidationSchema>
>;

export default LocationValidationSchema;
